// extracted by mini-css-extract-plugin
export default {"ServicesInventionsDocumet":"Document_ServicesInventionsDocumet__G8rlj","laws__link":"Document_laws__link__7D+M1"};